class ProgramGuide {
  constructor(el) {
    this.el = el;
    this.$el = $(el);

    this.$guideLinks = this.$el.find('[data-guide-link]');
    this.$guideSections = this.$el.find('[data-guide-section]');

    this.onClickGuideLink = this.onClickGuideLink.bind(this);

    this.bindEvents();
    
    this.currentSection = this.$guideSections.first().attr('id');
    this.navigateToSection(this.currentSection);

    window.grapp.instances = window.grapp.instances ? [...window.grapp.instances, this] : [this];
  }

  navigateToSection(id) {
    this.$guideSections.addClass('inactive').removeClass('active');
    this.$guideLinks.removeClass('active');

    this.currentSection = id;
    this.$guideSections.filter(`[id="${this.currentSection}"]`).addClass('active');
    this.$guideLinks.filter(`[href="#${this.currentSection}"]`).addClass('active');
  }

  bindEvents() {
    this.$guideLinks.on('click', this.onClickGuideLink);
  }

  onClickGuideLink(e) {
    const href = $(e.currentTarget).attr('href');
    const id = href.replace('#', '');
    this.navigateToSection(id);
  }

  static init() {
    $('[data-js-component="program-guide"]').each((i, el) => new ProgramGuide(el));
  }
}

ProgramGuide.init();
